import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  ListAuditsCommand,
  ListAuditsCommandInput,
  GetAuditCommand,
  GetAuditCommandInput,
  CreateAuditCommandInput,
  CreateAuditCommand,
  UpdateAuditCommand,
  ReopenAuditCommandInput,
  ReopenAuditCommand,
  SearchAuditsCommandInput,
  SearchAuditsCommand,
  GetAuditSummaryCommandInput,
  GetAuditSummaryCommand,
  GetAuditStatsCommandInput,
  GetAuditStatsCommand,
} from '@amzn/gbsa-helios-typescript-client';
import { UpdateAuditCommandInput } from '@amzn/gbsa-helios-typescript-client';

export const auditService = {
  // Get all audits
  getAll: (data: ListAuditsCommandInput) => {
    return apiHeliosClient.send(new ListAuditsCommand(data));
  },

  // Get audit by ID
  getById: (data: GetAuditCommandInput) => {
    return apiHeliosClient.send(new GetAuditCommand(data));
  },

  // Create new audit
  create: (data: CreateAuditCommandInput) => {
    return apiHeliosClient.send(new CreateAuditCommand(data));
  },

  // Update audit
  update: (data: UpdateAuditCommandInput) => {
    return apiHeliosClient.send(new UpdateAuditCommand(data));
  },

  // Reopen audit
  reopen: (data: ReopenAuditCommandInput) => {
    return apiHeliosClient.send(new ReopenAuditCommand(data));
  },

  // Search audits
  search: (data: SearchAuditsCommandInput) => {
    return apiHeliosClient.send(new SearchAuditsCommand(data));
  },

  // Get audit summary
  getSummary: (data: GetAuditSummaryCommandInput) => {
    return apiHeliosClient.send(new GetAuditSummaryCommand(data));
  },

  // Get audit stats
  getStats: (data: GetAuditStatsCommandInput) => {
    return apiHeliosClient.send(new GetAuditStatsCommand(data));
  },
};
